export default __webpack_public_path__ + "static/unassigned-image-1-69d803f33a899d899d2fd33da4b8d1b3.png";